class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("click", async (event) => {
      try {
        event.preventDefault();
        const cartItems =
          this.closest("cart-items") || this.closest("cart-drawer-items");

        console.log("Removing item at index:", this.dataset.index);

        // Await updateQuantity
        let parsedState = await cartItems.updateQuantity(
          this.dataset.index,
          0
        );

        console.log("Update result:", parsedState);

        if (parsedState && typeof parsedState === "object") {
          console.log("Update successful! Item count:", parsedState.item_count);

          console.log("Calling getCart...");
          let cartCheckResult = await this.getCart(cartItems);
          console.log("getCart result:", cartCheckResult);
        } else {
          console.error("Update failed or returned invalid result");
        }
      } catch (error) {
        console.error("Error during cart update process:", error);
      }
    });
  }

  async getCart(cartItems1) {
    try {
      const cartInfo = await fetch("https://helloasia.ch/cart.js");
      const cartData = await cartInfo.json();

      let checkFrozenFood = false;
      let checkFreshFoodDelivery = false;

      // Kiểm tra loại hàng trong giỏ
      cartData.items.forEach((item) => {
        console.log(132123123123123123123)
        console.log(item.properties)
        if (
          item.product_type === "frozen_food" ||
          ["50193688428808", "49970641666312", "50051770581256"].includes(
            String(item.id)
          )
        ) {
          checkFrozenFood = true;
        }

        if (item.properties?.FreshFoodDelivery == "true") {
          checkFreshFoodDelivery = true;
        }
      });

      console.log(cartData.items)

      // Hàm chung để xoá item theo variant id
      const removeItemIfExists = async (cartItems1, variantId) => {
        const cartItemsWrapper =
          document.querySelector(".drawer__cart-items-wrapper") ||
          document.querySelector(".body_cart_items");
        console.log(cartItemsWrapper);
        if (!cartItemsWrapper) return false;

        // Gộp selector để lấy được cả 2 loại item
        const cartItems = cartItemsWrapper.querySelectorAll(".drawer__cart-item, .cart-item");
        console.log(cartItems);
        if (!cartItems.length) return false;

        const linkSelector = `a[href*="variant=${encodeURIComponent(String(variantId))}"]`;
        const itemsArr = Array.from(cartItems);
        console.log(linkSelector)
        console.log(itemsArr)

        // Tìm item đầu tiên khớp variant
        const idx = itemsArr.findIndex(el => el.querySelector(linkSelector));
        if (idx === -1) return false;

        // Nếu DOM có sẵn index/line, ưu tiên dùng; fallback là idx + 1
        const line =
          Number(itemsArr[idx].dataset.index) ||
          Number(itemsArr[idx].dataset.line) ||
          (idx + 1);
        console.log('line',line)
        try {
          const parsedState = await cartItems1.updateQuantity(line, 0);
          if (parsedState && typeof parsedState === "object") {
            cartItems1.updateLiveRegions(line, parsedState.item_count);
          }
          return true;
        } catch (e) {
          console.error("removeItemIfExists error:", e);
          return false;
        }
      };
      console.log(checkFrozenFood)
      // Nếu không có frozen food thì xoá variant 50342804390152
      if (checkFrozenFood == false) {
        console.log(1112312)
        await removeItemIfExists(cartItems1,"50342804390152");
      }

      // Nếu không có fresh food delivery thì xoá variant 52208339288328
      if (checkFreshFoodDelivery == false) {
        await removeItemIfExists(cartItems1,"52208339288328");
      }

      return checkFrozenFood;
    } catch (error) {
      console.error("Error fetching cart:", error);
      return false;
    }
  }

  getSectionsToRender() {
    return [
      { id: "cart-drawer", selector: "#CartDrawer" },
      { id: "cart-icon-bubble" },
      { id: "cart-icon-bubble--mobile" },
      { id: "cart-free-delivery" },
    ];
  }
}

customElements.define("cart-remove-button", CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement =
      document.getElementById("shopping-cart-line-item-status") ||
      document.getElementById("CartDrawer-LineItemStatus");

    this.currentItemCount = Array.from(
      this.querySelectorAll('[name="updates[]"]')
    ).reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener("change", this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    this.updateQuantity(
      event.target.dataset.index,
      event.target.value,
      document.activeElement.getAttribute("name")
    );
  }

  getSectionsToRender() {
    return [
      {
        id: "main-cart-items",
        section: document.getElementById("main-cart-items").dataset.id,
        selector: ".js-contents",
      },
      {
        id: "cart-icon-bubble",
        section: "cart-icon-bubble",
        selector: ".shopify-section",
      },
      {
        id: "cart-icon-bubble--mobile",
        section: "cart-icon-bubble--mobile",
        selector: ".shopify-section",
      },
      {
        id: "cart-live-region-text",
        section: "cart-live-region-text",
        selector: ".shopify-section",
      },
      {
        id: "main-cart-footer",
        section: document.getElementById("main-cart-footer").dataset.id,
        selector: ".js-contents",
      },
    ];
  }

  async getCart() {
    console.log("abc")
    try {
      let cartInfo = await fetch("https://helloasia.ch/cart.js");
      let cartData = await cartInfo.json();
      let checkFrozenFood = false;
      let checkFreshFoodDelivery = false;

      cartData.items.forEach((item) => {
        if (
          item.product_type === "frozen_food" ||
          ["50193688428808", "49970641666312", "50051770581256"].includes(
            String(item.id)
          )
        ) {
          checkFrozenFood = true;
        }
      });

      cartData.items.forEach((item) => {
        console.log(132123123123123123123 + "adshdgjahsd")

        console.log(item.properties)
        if (item.properties && item.properties.FreshFoodDelivery == "true") {
          checkFreshFoodDelivery = true;
        }
      });

      // Remove fresh_food if no FreshFoodDelivery
      if (!checkFreshFoodDelivery) {
        const cartItemsWrapper = document.querySelector(".cart-items");
        const cartItems = cartItemsWrapper.querySelectorAll(".cart-item");
        let itemToRemove = null;
        let itemPosition = -1;

        cartItems.forEach((item, index) => {
          if (item.dataset.type === "fresh_food") {
            itemToRemove = item;
            itemPosition = index;
          }
        });

        if (itemToRemove) {
          itemToRemove.remove();
          console.log(`Removed fresh_food at position ${itemPosition}`);

          const url = "/cart/change.js";
          const options = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              line: itemPosition + 1,
              quantity: 0,
              sections: this.getSectionsToRender().map(
                (section) => section.section
              ),
              sections_url: window.location.pathname,
            }),
          };

          let response = await fetch(url, options);
          let state = await response.json();

          this.classList.toggle("is-empty", state.item_count === 0);

          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");
          if (cartFooter)
            cartFooter.classList.toggle("is-empty", state.item_count === 0);
          if (cartDrawerWrapper)
            cartDrawerWrapper.classList.toggle("is-empty", state.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              state.sections[section.section],
              section.selector
            );
          });

          this.updateLiveRegions(itemPosition + 1, state.item_count);
        }
      }

      // Remove bag if no frozen_food
      if (!checkFrozenFood) {
        const cartItemsWrapper = document.querySelector(".cart-items");
        const cartItems = cartItemsWrapper.querySelectorAll(".cart-item");
        let itemToRemove = null;
        let itemPosition = -1;

        cartItems.forEach((item, index) => {
          if (item.dataset.type === "bag") {
            itemToRemove = item;
            itemPosition = index;
          }
        });

        if (itemToRemove) {
          itemToRemove.remove();
          console.log(`Removed bag at position ${itemPosition}`);

          const url = "/cart/change.js";
          const options = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              line: itemPosition + 1,
              quantity: 0,
              sections: this.getSectionsToRender().map(
                (section) => section.section
              ),
              sections_url: window.location.pathname,
            }),
          };

          let response = await fetch(url, options);
          let state = await response.json();

          this.classList.toggle("is-empty", state.item_count === 0);

          const cartDrawerWrapper = document.querySelector("cart-drawer");
          const cartFooter = document.getElementById("main-cart-footer");
          if (cartFooter)
            cartFooter.classList.toggle("is-empty", state.item_count === 0);
          if (cartDrawerWrapper)
            cartDrawerWrapper.classList.toggle("is-empty", state.item_count === 0);

          this.getSectionsToRender().forEach((section) => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) ||
              document.getElementById(section.id);
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              state.sections[section.section],
              section.selector
            );
          });

          this.updateLiveRegions(itemPosition + 1, state.item_count);
        }
      }

      return checkFrozenFood;
    } catch (error) {
      console.error("Error fetching cart:", error);
      return false;
    }
  }

  async updateQuantity(line, quantity, name) {
    console.log("line", line);
    return new Promise(async (resolve, reject) => {
      try {
        this.enableLoading(line);

        const body = JSON.stringify({
          line,
          quantity,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.text())
          .then(async (state) => {
            const parsedState = JSON.parse(state);
            this.classList.toggle("is-empty", parsedState.item_count === 0);

            const cartDrawerWrapper = document.querySelector("cart-drawer");
            const cartFooter = document.getElementById("main-cart-footer");
            if (cartFooter)
              cartFooter.classList.toggle("is-empty", parsedState.item_count === 0);
            if (cartDrawerWrapper)
              cartDrawerWrapper.classList.toggle("is-empty", parsedState.item_count === 0);

            this.getSectionsToRender().forEach((section) => {
              const elementToReplace =
                document.getElementById(section.id).querySelector(section.selector) ||
                document.getElementById(section.id);
              elementToReplace.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.section],
                section.selector
              );
            });

            this.updateLiveRegions(line, parsedState.item_count);

            this.disableLoading();
            resolve(parsedState);
          })
          .catch((err) => {
            console.error(err);
            this.querySelectorAll(".loading-overlay").forEach((overlay) =>
              overlay.classList.add("hidden")
            );
            const errors =
              document.getElementById("cart-errors") ||
              document.getElementById("CartDrawer-CartErrors");
            errors.textContent = window.cartStrings.error;
            this.disableLoading();
            reject(err);
          });
      } catch (e) {
        console.error(e);
        reject(e);
      }
    });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemError =
        document.getElementById(`Line-item-error-${line}`) ||
        document.getElementById(`CartDrawer-LineItemError-${line}`);
      const quantityElement =
        document.getElementById(`Quantity-${line}`) ||
        document.getElementById(`Drawer-quantity-${line}`);
      if (lineItemError && quantityElement) {
        lineItemError.querySelector(".cart-item__error-text").innerHTML =
          window.cartStrings.quantityError.replace(
            "[quantity]",
            quantityElement.value
          );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute("aria-hidden", true);

    const cartStatus =
      document.getElementById("cart-live-region-text") ||
      document.getElementById("CartDrawer-LiveRegionText");
    cartStatus.setAttribute("aria-hidden", false);

    setTimeout(() => {
      cartStatus.setAttribute("aria-hidden", true);
    }, 1000);
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, "text/html")
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.add("cart__items--disabled");

    const cartItemElements = this.querySelectorAll(
      `#CartItem-${line} .loading-overlay`
    );
    const cartDrawerItemElements = this.querySelectorAll(
      `#CartDrawer-Item-${line} .loading-overlay`
    );

    [...cartItemElements, ...cartDrawerItemElements].forEach((overlay) =>
      overlay.classList.remove("hidden")
    );

    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute("aria-hidden", false);
  }

  disableLoading() {
    const mainCartItems =
      document.getElementById("main-cart-items") ||
      document.getElementById("CartDrawer-CartItems");
    mainCartItems.classList.remove("cart__items--disabled");
  }
}

customElements.define("cart-items", CartItems);

if (!customElements.get("cart-note")) {
  customElements.define(
    "cart-note",
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this.addEventListener(
          "change",
          debounce((event) => {
            const body = JSON.stringify({ note: event.target.value });
            fetch(`${routes.cart_update_url}`, {
              ...fetchConfig(),
              ...{ body },
            });
          }, 300)
        );
      }
    }
  );
}
